import React from 'react';
import NotificationSender from '../components/NotificationSender';
import { Box, Typography, Container, Card, CardContent } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

const SendNotificationPage: React.FC = () => {
  const token = localStorage.getItem('token');
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header Section */}
      <Box sx={{ 
        mb: 4, 
        textAlign: 'center',
        p: 2
      }}>
        <Typography variant="h3" gutterBottom sx={{ 
          fontWeight: 700, 
          color: '#2c3e50',
          mb: 2
        }}>
          Send Push Notification
        </Typography>
        <Typography variant="subtitle1" sx={{ 
          color: '#7f8c8d',
          fontWeight: 400
        }}>
          Send targeted notifications to users and manage communication
        </Typography>
      </Box>

      {/* Main Content Card */}
      <Card sx={{ 
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        border: '1px solid #e1e8ed',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 25px rgba(52, 152, 219, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <Box sx={{ 
              p: 1, 
              borderRadius: 2, 
              background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
              color: 'white',
              mr: 2
            }}>
              <NotificationsIcon />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
              Notification Composer
            </Typography>
          </Box>
          
          <NotificationSender token={token || ''} />
        </CardContent>
      </Card>
    </Container>
  );
};

export default SendNotificationPage; 